import { Bar } from 'recharts';

export function ActivityBars() {
  return (
    <>
      <Bar
        dataKey="mensagens"
        fill="var(--color-mensagens)"
        radius={[4, 4, 0, 0]}
        maxBarSize={40}
        animationDuration={1000}
        animationBegin={200}
      />
      <Bar
        dataKey="agendamentos"
        fill="var(--color-agendamentos)"
        radius={[4, 4, 0, 0]}
        maxBarSize={40}
        animationDuration={1000}
        animationBegin={400}
      />
    </>
  );
}